import { type ReactElement } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import { HOME_HEALTH_CASES_PATH } from "../ExperimentalHomeHealth/Cases/paths";
import { HOME_HEALTH_VISIT_VERIFICATION_PATH } from "../ExperimentalHomeHealth/VisitVerification/paths";
import { HELP_CENTER_PATH } from "../HelpCenter/paths";
import { NotFoundPage } from "../lib";
import { HelpCenterPage } from "../redesign/HelpCenter/Page";

export function AppV2PrivateRoutes(): ReactElement {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${match.url}/${HELP_CENTER_PATH}`}>
        <HelpCenterPage />
      </Route>
      <Route exact path={match.url}>
        <div>This is a private route from appV2</div>
      </Route>
      <Redirect from={`${match.url}/home-health/cases`} to={HOME_HEALTH_CASES_PATH} />
      <Redirect
        from={`${match.url}/home-health/visit-verification`}
        to={HOME_HEALTH_VISIT_VERIFICATION_PATH}
      />
      <Route path="*">
        <NotFoundPage />
      </Route>
    </Switch>
  );
}
